/**
 * imageddlChange / UpdateProductImage — product-image swap heuristics,
 * verbatim (REQ-PRICE-8; research/04 §4.5). Swatch radio uses data-imgsrc on
 * the input; dropdown reads the selected option's data-imgsrc; the first
 * visible [class^=product]>img matching the CDN/calcset heuristic is
 * updated, then one img[role="presentation"].
 */
import $ from "jquery";
export function imageddlChange(element: any): void {
  let isRadio = $(element).is(":radio");
  var showImage = $(element).data("showimage");
  if (isRadio === true) {
    //Swatch
    if (showImage === true) {
      let imgsrc = $(element).data("imgsrc");
      UpdateProductImage(imgsrc);
    }
  } else {
    //Dropdown
    if (showImage === true) {
      let imgsrc = $(element).children("option:selected").data("imgsrc");
      UpdateProductImage(imgsrc);
    }
  }
}

export function UpdateProductImage(imgSrc: any): void {
  var imageSelectors = document.querySelectorAll("[class^=product]>img");
  let isImageUpdated = false;
  let isPresentationUpdated = false;
  imageSelectors.forEach((elem: any) => {
    var pro_isHidden = $(elem).is(":hidden");
    if (pro_isHidden === false) {
      if (isImageUpdated === false) {
        var calcSet = elem.getAttribute("calcset");
        var dataIndex = elem.getAttribute("data-index");
        var isDataIndexConditionSatisfied =
          dataIndex === null || dataIndex === "1";
        var storeURL = window.location.host + "/cdn";
        if (
          (elem.src.includes("cdn.shopify.com") ||
            elem.srcset.includes("cdn.shopify.com") ||
            elem.src.includes("myshopify.com") ||
            elem.srcset.includes("myshopify.com") ||
            elem.src.includes(storeURL) ||
            elem.srcset.includes(storeURL) ||
            calcSet === "true") &&
          isDataIndexConditionSatisfied === true
        ) {
          isImageUpdated = true;
          elem.setAttribute("src", imgSrc);
          elem.setAttribute("calcset", true);
          elem.setAttribute("data-srcset", "");
          elem.setAttribute("data-zoom", imgSrc);
          elem.setAttribute("srcset", "");
        }
      } else if (isImageUpdated === true && isPresentationUpdated === false) {
        var imageElement = document.querySelector('img[role="presentation"]');
        if (imageElement !== null && imageElement !== undefined) {
          isPresentationUpdated = true;
          imageElement.setAttribute("src", imgSrc);
          imageElement.setAttribute("calcset", true as any);
          imageElement.setAttribute("data-zoom", imgSrc);
          imageElement.setAttribute("data-srcset", "");
          imageElement.setAttribute("srcset", "");
        }
      }
    }
  });
}
